<p-dialog
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-full max-w-2xl"
  data-testid="provider-contact-modal"
>
  <ng-template #header>
    <h2 class="text-xl font-semibold text-white">
      {{ displayProviderName() }}
    </h2>
  </ng-template>

  @if (loading()) {
    <app-loading />
  } @else if (contactPerson()) {
    <div class="flex flex-col gap-3">
      <div>
        <p class="text-sm text-gray-500">
          {{ 'project.steps.rfd.invitationList.contactModal.name' | transloco }}
        </p>
        <p class="font-medium text-white">{{ contactPerson()!.name }}</p>
      </div>
      <div>
        <p class="text-sm text-gray-500">
          {{ 'project.steps.rfd.invitationList.contactModal.email' | transloco }}
        </p>
        <a class="text-white" [href]="'mailto:' + contactPerson()!.email">
          {{ contactPerson()!.email }}
        </a>
      </div>
      <div>
        <p class="text-sm text-gray-500">
          {{ 'project.steps.rfd.invitationList.contactModal.phone' | transloco }}
        </p>
        <a class="text-white" [href]="'tel:' + contactPerson()!.phoneNumber">
          {{ contactPerson()!.phoneNumber }}
        </a>
      </div>
    </div>
  } @else {
    <p class="text-sm text-gray-500">
      {{ 'project.steps.rfd.invitationList.contactModal.empty' | transloco }}
    </p>
  }
</p-dialog>
